/**
 * Included into the footer of pages.
 */

import './lib/AnimationEasing';

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	// customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});


// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance(
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .site-footer__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .site-footer__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// );
// ---------------------------------------------------------------------------------------------- //



/**
	Adds/removes a "hidden" class on ".wp-block-group-form-intro" depending on whether
	the .client-side-interface table has "tr.msa-quote-request-product-row" in its body.
	Uses MutationObserver so it works even when the table loads/updates later.
*/
(() => {
	const INTRO_SELECTOR = ".wp-block-group-form-intro";
	const FORM_SELECTOR = "form#gform_2"; // adjust if needed
	const TABLE_SELECTOR = "table.client-side-interface";
	const ROW_SELECTOR = "tbody tr.msa-quote-request-product-row";
	const HIDDEN_CLASS = "hidden";
  
	const update = () => {
		const table = document.querySelector<HTMLTableElement>(TABLE_SELECTOR);
		const hasRows = !!table?.querySelector(ROW_SELECTOR);
		const intro = document.querySelector<HTMLElement>(INTRO_SELECTOR);
		intro?.classList.toggle(HIDDEN_CLASS, hasRows);
		const form = document.querySelector<HTMLFormElement>(FORM_SELECTOR);
		form?.classList.toggle(HIDDEN_CLASS, !hasRows);
	};
  
	const start = () => {
		update();

		const observer = new MutationObserver(update);
			observer.observe(document.documentElement, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["class"],
		});
	};
  
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start, { once: true });
	} else {
		start();
	}
  })();